import { render, staticRenderFns } from "./MyPlanet.vue?vue&type=template&id=59c20591&scoped=true"
import script from "./MyPlanet.vue?vue&type=script&lang=js"
export * from "./MyPlanet.vue?vue&type=script&lang=js"
import style0 from "./MyPlanet.vue?vue&type=style&index=0&id=59c20591&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c20591",
  null
  
)

export default component.exports